import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import App from "../../containers/App";
import ScrollManager from "../../containers/ScrollManager";

const Root = ({ innerRef, store, history, ...innerProps }) => (
  <Provider ref={innerRef} store={store}>
    <ConnectedRouter history={history}>
      <ScrollManager>
        {scrollHandlers => <App {...scrollHandlers} {...innerProps} />}
      </ScrollManager>
    </ConnectedRouter>
  </Provider>
);

Root.defaultProps = {
  innerRef: () => {}
};

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  innerRef: PropTypes.func
};

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root/Root.js